import { NgModule } from '@angular/core';
import { FlexLayoutModule, FlexModule } from '@angular/flex-layout';
import { FbCoreModule } from '@fleet-beat/core';
import { WrapPanelComponent } from './components/wrap-panel/wrap-panel.component';
import { WrapPanelItemDirective } from './directives/wrap-panel-item.directive';
import { WrapPanelWidthPipe } from './pipes/wrap-panel-width.pipe';

@NgModule({
  declarations: [WrapPanelComponent, WrapPanelItemDirective, WrapPanelWidthPipe],
  exports: [WrapPanelComponent, WrapPanelItemDirective],
  imports: [FbCoreModule, FlexModule, FlexLayoutModule],
})
export class WrapPanelModule {}
